/* globals $ */
import moment from 'moment';
export function initialise() {
    if (!document.querySelector(".kmscalendar"))
        return;
        
    if (typeof $ !== 'function'){
        console.error("Calendar display requires jquery to be loaded.");
        return;
    }
    //Load CSS and javascript
    $('head').append('<link rel="stylesheet" type="text/css" href="//cdnjs.cloudflare.com/ajax/libs/fullcalendar/2.7.1/fullcalendar.min.css">');
    $('head').append('<link rel="stylesheet" media="print" type="text/css" href="//cdnjs.cloudflare.com/ajax/libs/fullcalendar/2.7.1/fullcalendar.print.css">');

    $.getScript('//cdnjs.cloudflare.com/ajax/libs/fullcalendar/2.9.1/fullcalendar.min.js',function(){
        $(".kmscalendar").each(function(index,el){
            var $el = $(el);
            var cal_load = function(){
                $el.fullCalendar({
                    // options and callbacks here.
                    viewRender: function(){
                        $el.find('.loading').remove();
                    },
                    eventRender: function(event, element) {
                        var ntoday = new Date().getTime();
                        var eventEnd = moment( event.end ).valueOf();
                        var eventStart = moment( event.start ).valueOf();
                        if (!event.end){
                            if (eventStart < ntoday){
                                element.addClass("fc-past-event");
                                element.children().addClass("fc-past-event");
                            }
                        } else {
                            if (eventEnd < ntoday){
                                element.addClass("fc-past-event");
                                element.children().addClass("fc-past-event");
                            }
                        }
                    },
                    eventSources:[
                        {
                            url:'/kms/events/?format=json'
                        }
                    ]
                });
            }
            if ($el.is(":visible")) {
                cal_load();
            } else {
                $(el).one('load-calendar', cal_load);
            }
        });
    });
}
